const nameMaxLength = 50;
const descriptionMaxLength = 500;

const phoneNumberMinLength = 13;
const phoneNumberMaxLength = 16;

export {
  nameMaxLength,
  descriptionMaxLength,
  phoneNumberMinLength,
  phoneNumberMaxLength,
};
